import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Loading,
  TextField,
} from "../../../../components";
import { notification, ProdutosService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const produtosService = new ProdutosService();

const CopiarProdutoDialog = ({ open, setOpen, handleCopiarProduto }) => {
  const [produtos, setProdutos] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [produtoSelecionadoId, setProdutoSelecionadoId] = useState(null);
  const [busca, setBusca] = useState("");
  const [loading, setLoading] = useState(false);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      width: 110,
      valueGetter: (params) => Number(params.value),
    },
    {
      field: "codigoBarra",
      headerName: "Código de Barra",
      width: 180,
      sortable: false,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      width: 150,
      sortable: false,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) =>
        formatPrice(params.row?.informacao?.precoVenda || 0),
    },
    {
      field: "estoque",
      headerName: "Estoque",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.estoqueProduto?.estoque ?? 0,
    },
  ];

  const buscarProdutos = (filtros = {}) => {
    setLoading(true);
    produtosService
      .getAllProdutosSimples({
        ativado: true,
        orderBy: "descricao",
        order: "asc",
        ...filtros,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setProdutos(result.data.rows);
          setRowCount(result.data.count);
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open) {
      buscarProdutos();
    }
  }, [open]);

  const handlePesquisar = (e) => {
    if (e) e.preventDefault();
    setProdutoSelecionadoId(null);
    buscarProdutos(busca ? { descricao: busca } : {});
  };

  const sendServerDatagrid = (props) => {
    buscarProdutos({
      ...(busca ? { descricao: busca } : {}),
      ...props.filtros,
    });
  };

  const handleClose = () => {
    setBusca("");
    setProdutos([]);
    setProdutoSelecionadoId(null);
    setOpen(false);
  };

  const confirmarCopia = async () => {
    if (!produtoSelecionadoId) {
      return notification.alertaGenericos(
        "Selecione um produto para copiar",
      );
    }
    setLoading(true);
    await handleCopiarProduto(produtoSelecionadoId);
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <CardHeader
        title="Copiar Produto"
        className="m-2"
        action={
          <IconButton color="inherit" onClick={handleClose}>
            <i className="ph-bold ph-x" style={{ fontSize: 20 }}></i>
          </IconButton>
        }
      />
      <DialogContent>
        <Box
          component="form"
          onSubmit={handlePesquisar}
          sx={{ display: "flex", gap: 1, mb: 2 }}
        >
          <TextField
            fullWidth
            label="Pesquisar por descrição"
            variant="outlined"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          <Button type="submit" variant="contained" sx={{ minWidth: 120 }}>
            Buscar
          </Button>
        </Box>
        <DataGrid
          checkboxSelection
          selectionModel={[produtoSelecionadoId]}
          onRowSelectionModelChange={(selectedIds) => {
            const id =
              selectedIds?.length > 1 ? [selectedIds.pop()] : selectedIds;
            setProdutoSelecionadoId(id[0] ?? null);
          }}
          paginationMode="server"
          sendServer={sendServerDatagrid}
          noFilter
          rows={produtos}
          columns={colunas}
          rowCount={rowCount}
          disableAcoes
        />
      </DialogContent>
      <DialogActions className="m-3">
        <Button onClick={handleClose} color="padrao" variant="contained">
          Cancelar
        </Button>
        <Button color="success" variant="contained" onClick={confirmarCopia}>
          Confirmar
        </Button>
      </DialogActions>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default CopiarProdutoDialog;
